import { Component, OnInit } from '@angular/core';

import { ClosableModal, ModalService } from '../../../../shared/modules/modal';

@Component({
  selector: 'apply-capital-adjustments-modal',
  templateUrl: './apply-capital-adjustments-modal.component.html',
})
export class ApplyCapitalAdjustmentsModalComponent extends ClosableModal implements OnInit {

  constructor(
    protected modalService: ModalService
  ) {
    super(modalService);
  }

  ngOnInit(): void {
  }

  close(): void {
    this.closeAllModals();
  }

}
